import ReactSelect from 'react-select';
import './style.scss';

const customStyle = {
	control: (base, state) =>
		state.isFocused
			? {
					...base,
					borderColor: '#00a0d2',
					boxShadow:
						'0 0 0 1px #00a0d2, 0 0 4px rgba(0,160,210, 0.3), 0 0 10px rgba(0,160,210, 0.1)',
			  }
			: base,
	option: (base, state) =>
		state.isSelected
			? {
					...base,
					backgroundColor: '#0085ba',
			  }
			: {
					...base,
					'&:hover': {
						backgroundColor: 'rgba(0,160,210, 0.1)',
					},
			  },
};

const Select = props => (
	<ReactSelect
		{...props}
		styles={customStyle}
		classNamePrefix="eform-gtb-react-select"
	/>
);

export default Select;
